import React, { useEffect, useState } from 'react';
import axios from 'axios';


function DocumentsTab({ caseId }) {
  const [documents, setDocuments] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const fetchDocuments = async () => {
    const token = localStorage.getItem("token");

    
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/document/case/${caseId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      
      setDocuments(res.data);
    } catch (error) {
      console.error('Error fetching documents:', error);
    }
  };

  useEffect(() => {
    if (caseId) fetchDocuments();
  }, [caseId]);

  return (
    <div className="space-y-4">
  
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {documents.map((doc) => (
          <div key={doc._id} className="bg-white p-4 border rounded shadow">
            <h3 className="font-bold text-lg">{doc.title}</h3>
            <p>Type: {doc.type}</p>
            <p>Uploaded By: {doc.uploadedBy}</p>
            <p>Description: {doc.description}</p>
            <a
              href={doc.fileUrl}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline mt-2 inline-block"
            >
              View Document
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DocumentsTab;
